import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  Dropdown, Menu,
  // $FlowFixMe
} from '@bijie/react-bnb';
// $FlowFixMe
import { getLabel } from '../../utils/i18n';
import withi18n from '../../utils/withI18n';
import FlexBox from '../FlexBox';
import Icon from '../Icon';
import featureConfig from '../../config/feature';
import SearchInput from '../SearchInput';

import {
  TabContainer, Tabs, Tab, SelectMarketsBox,
  SearchBox,
} from '../IndexSymbolsList';

import EmptyTable from '../EmptyTable';
import { getAssetMinTradeInfo } from '../../actions/actionsSet/asset';

const { MenuItem } = Menu;
const { defaultSelectedStableCoinTabs } = featureConfig;
const STABLE_COIN_BASES = Object.keys(defaultSelectedStableCoinTabs);


const Wrap = styled.div`
  width: 1260px;
  padding: 45px 0;
  margin: 0 auto;
  padding-top: 90px;
  position: relative;
  input{
    font-size:16px;
    ::-webkit-input-placeholder {
      font-size: 16px;
    }
    ::-moz-placeholder {
      font-size: 16px;
    }
    :-ms-input-placeholder {
      font-size: 16px;
    }
  }

 & h1{
    font-size: 34px;
    margin-bottom:0;
 }
`;


const columns = (i18n) => [
  {
    title: `${getLabel('exchange-common-pair', i18n)}`,
    dataIndex: 'baseAsset',
    width: '10%',
    render(_, item) {
      return `${item.baseAsset}/${item.quoteAsset}`;
    },
  },
  {
    title: `${getLabel('exchange-common-minTradeAmount', i18n)}`,
    dataIndex: 'minTradeAmount',
    render(_, item) {
      return `${item.minTradeAmount} ${item.baseAsset}`;
    },
  },
  {
    title: `${getLabel('exchange-common-minPriceMovement', i18n)}`,
    dataIndex: 'minTickSize',
    render(_, item) {
      return `${item.minTickSize} ${item.quoteAsset}`;
    },
  },
  {
    title: `${getLabel('exchange-common-minOrderSize', i18n)}`,
    dataIndex: 'minOrderValue',
    render(_, item) {
      return `${item.minOrderValue} ${item.quoteAsset}`;
    },
  },
  {
    title: `${getLabel('exchange-common-maxMarketOrderAmount', i18n)}`,
    dataIndex: 'maxMarketOrderQty',
    render(_, item) {
      // eslint-disable-next-line prefer-template
      return `${item.maxMarketOrderQty === null ? '--' : (item.maxMarketOrderQty + ' ' + item.baseAsset)}`;
    },
  },
  // {
  //   title: `${getLabel('exchange-common-minMarketOrderAmount', i18n)}`,
  //   dataIndex: 'minMarketOrderQty',
  //   render(_, item) {
  //     // eslint-disable-next-line prefer-template
  //     return `${item.minMarketOrderQty === null ? '--' : (item.minMarketOrderQty + ' ' + item.baseAsset)}`;
  //   },
  // },
];
type Props = {
  i18n: Object,
  locale: string,
  tickers: Array<Object>,
  getAssetMinTradeInfo: Function,
  assetMinTradeInfo: Array<Object>,
}

const mapStateToProps = ({
  tickers,
  locale,
  assetMinTradeInfo,
}) => ({
  tickers,
  locale,
  assetMinTradeInfo,
});

const mapDispatchToProps = ({
  getAssetMinTradeInfo,
});
export default
@withi18n
@connect(
  mapStateToProps,
  mapDispatchToProps
)
class ReferralDetail extends React.Component<Props> {
  static defaultProps = {
    locale: 'en',
    i18n: {},
    tickers: [],
    assetMinTradeInfo: [],
    getAssetMinTradeInfo: () => {},
  };

  state = {
    filterKeyword: '',
    selectedAssetTab: 'BTC',
    selectedCoin: {
      'USDⓈ': 'ALL',
      'ALTS': 'ALL',
    },
  }

  componentDidMount() {
    this.props.getAssetMinTradeInfo();
  }


  _getParentMarketNames = () => {
    const { tickers } = this.props;
    const arr = [];
    Object.values(tickers).map(v => {
      const { pn } = v;
      if (!arr.includes(pn)) {
        arr.push(pn);
      }
      return null;
    });
    return arr;
  }

  _searchByKeyword = val => {
    this.setState({ filterKeyword: val });
  }

  _handleAssetTab = val => {
    this.setState({ selectedAssetTab: val });
  };

  _handleTabClick = (key, selectedCoinNew) => {
    const { selectedCoin } = this.state;
    const newSelectedCoin = Object.assign({}, selectedCoin);
    newSelectedCoin[selectedCoinNew] = key;
    this.setState({
      selectedCoin: newSelectedCoin,
    });
  };

  _getParentMarketNamesAndStableCoins = () => {
    const { tickers } = this.props;
    const stableCoins = {};
    STABLE_COIN_BASES.forEach(el => {
      stableCoins[el] = ['ALL'];
    });
    const list = Object.values(tickers);
    list.forEach(({ pn, qa }) => {
      STABLE_COIN_BASES.forEach((el: string) => {
        if (el === pn && STABLE_COIN_BASES.includes(pn) && !stableCoins[el].includes(qa)) {
          stableCoins[el].push(qa);
        }
      });
    });
    return stableCoins;
  };

  render() {
    const { i18n, assetMinTradeInfo } = this.props;
    const { selectedAssetTab, selectedCoin, filterKeyword } = this.state;
    const parentMarkets = this._getParentMarketNames();
    const stableCoins = this._getParentMarketNamesAndStableCoins();
    let filterData = assetMinTradeInfo;
    if (!stableCoins[selectedAssetTab]) {
      filterData = filterData.filter(x => x.quoteAsset === selectedAssetTab);
    } else if (selectedCoin[selectedAssetTab] !== 'ALL') {
      filterData = filterData.filter(x => x.quoteAsset === selectedCoin[selectedAssetTab]);
    } else {
      filterData = filterData.filter(x => stableCoins[selectedAssetTab].indexOf(x.quoteAsset) !== -1);
    }
    filterData = filterData.filter(x => x.baseAsset.startsWith(filterKeyword.toLocaleUpperCase()));
    if (filterData.length === 0) return null;
    return (
      <Wrap>
        <h1>{getLabel('exchange-tradeRule-title', i18n)}</h1>
        <TabContainer id="tabContainer" justify="space-between">
          <Tabs>
            {parentMarkets.map((v, i) => (
              <Tab
                id={`IndexSymbolsList-button-${v}Markets`}
                key={i}
                selected={selectedAssetTab === v}
                isStableCoinMarket={STABLE_COIN_BASES.includes(v)}
                onClick={() => this._handleAssetTab(v)}
              >
                {getLabel('exchange-home-Markets', i18n).replace('##', v)}
                {STABLE_COIN_BASES.includes(v) && (
                  <Dropdown
                    overlay={
                      <Menu mode="inline">
                        {stableCoins[v].map(item => (
                          <MenuItem key={item} onClick={() => this._handleTabClick(item, v)}>
                            {item === 'ALL' ? <Icon type="hamburger" size={12} /> : '-'}
                            &nbsp;&nbsp;{item}
                          </MenuItem>
                        ))}
                      </Menu>
                    }
                    trigger={['click']}
                  >
                    <SelectMarketsBox>
                      {selectedCoin[v]}
                      <Icon type="arrow-d" size={12} color="#848E9C" />
                    </SelectMarketsBox>
                  </Dropdown>
                )}
              </Tab>
            ))}
          </Tabs>
          <SearchBox fullScreen={true} justify="center" align="center">
            <SearchInput
              value={filterKeyword}
              placeholder={getLabel('exchange-tradeRule-SearchCoinName', i18n)}
              onChange={this._searchByKeyword}
              height="auto"
              width="400px"
            />
          </SearchBox>
        </TabContainer>
        <FlexBox margin="0px 0 0 0">
          <EmptyTable
            i18n={i18n}
            data={filterData}
            columns={columns(i18n)}
            emptyText={getLabel('exchange-DistributionTable-NoData', i18n)}
            pagination={false}
          />
        </FlexBox>
      </Wrap>
    );
  }
}
